module.exports = __webpack_public_path__ + "img/laying-down.098858b7.svg";